<template>
    <v-card 
        :loading="loading"
        elevation="2"
        tile
        outlined
        >
        <v-card-title class="pa-2 px-5 primary white--text align-center">
            {{ system.name }}
            <v-spacer/>
            <div class="text-overline">{{ system.sistema_type.slug }}</div>
            <v-divider vertical inset class="mx-2"/>
            <v-switch v-model="is_active" :loading="loading" :disabled="loading" hide-details="" class="ma-0" color="accent"/>
            <Modal :sistema="system" @saved="system = $event" dark/>
        </v-card-title>
        <v-divider/>
        <v-card-subtitle v-if="system.description">{{ system.description }}</v-card-subtitle>
        <v-card-text>
            <v-card class="mb-2" outlined tile>
                <v-card-text class="pa-2">
                    <div class="d-flex align-center flex-wrap">
                        <small class="caption mr-2">TOKEN</small>
                        <code style="overflow-wrap: anywhere;">
                            <template v-if="system.token">{{ system.token }} <v-btn x-small icon @click="copy(system.token)"><v-icon x-small>mdi-content-copy</v-icon></v-btn></template>
                            <template v-else>SIN TOKEN</template>
                        </code>
                        <v-spacer/>
                        <v-btn @click="renewToken()" :loading="loading" :disabled="loading" small tile>RENOVAR TOKEN</v-btn>
                    </div>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <div class="d-flex align-center flex-wrap">
                        <v-checkbox
                            v-for="(ability, index) of abilityList"
                            :key="`ability-${index}-${ability}`"
                            class="mr-2"
                            v-model="selectedAbilities"
                            :label="ability"
                            :value="ability"
                            dense
                            hide-details=""
                            :disabled="loading || settingAbilities"
                            />
                            <v-progress-circular v-if="settingAbilities" indeterminate size="20" class="mt-2"/>
                    </div>
                </v-card-actions>
            </v-card>
            <v-card flat>
                <v-card-title class="pa-0">
                    <div class="text-uppercase text-overline">Juegos</div>
                    <v-spacer/>
                    <CupoModal :sistema="sistema"/>
                </v-card-title>
                <v-card-text class="pa-0">
                    <Cupo :sistema="sistema"/>
                </v-card-text>
            </v-card>
        </v-card-text>
    </v-card>
</template>
<script>
import SistemaService from '@/services/operadora/comercio/sistema/SistemaService';

import Modal from './modal';
import CupoModal from './cupo/modal';
import Cupo from './cupo';

export default {
    components: {
        Modal,
        CupoModal,
        Cupo
    },
    props: {
        sistema: {
            required: true
        },
        abilities: {
            required: true
        }
    },
    data: function () {
        return {
            system: this.sistema,
            selectedAbilities: this.sistema.abilities,
            is_active: this.sistema.is_active,
            loading: false,
            settingAbilities: false,
        }
    },
    computed: {
        abilityList: function () {
            return this.abilities.filter(ability => ability.startsWith("api:sistema"));
        }
    },
    methods: {
        setIsActive(is_active) {
            this.loading = true;
            SistemaService
                .update(this.system.id, { sistema: { is_active } })
                .then(({ sistema }) => {
                    this.system = sistema;
                }).finally(() => {
                    this.loading = false;
                });
        },
        renewToken() {
            this.$ui.confirm({
                message: `Confirmar renofación de token: ${this.sistema.name}`,
                textConfirm: 'RENOVAR',
                textCancel: 'CANCELAR',
                confirm: () => {
                    this.loading = true;
                    SistemaService
                        .renewToken(this.system.id)
                        .then(({ sistema }) => {
                            this.system = sistema;
                        }).finally(() => {
                            this.loading = false;
                        });
                },
            });
        },
        async copy(text) {
            try {
                await navigator.clipboard.writeText(text);
            } catch (e) {
                console.error(e);
            }
        }
    },
    watch: {
        is_active: function (value) {
            this.setIsActive(value);
        },
        selectedAbilities: {
            deep: true,
            handler: function (value) {
                this.settingAbilities = true;
                SistemaService
                   .setAbilities(this.system.id, value)
                   .then(({ sistema }) => {
                        this.system = sistema;
                    }).finally(() => {
                        this.settingAbilities = false;
                    });
            }
        }
    }
}
</script>